import axios from "axios";
import {watch} from "vue";

export default {
    search: (endpoint, query, identifiers, callback) => {
        let lastQuery = undefined;
        let searchTimeout = undefined;

        function search() {
            if (lastQuery !== undefined && lastQuery === query.value) return;
            lastQuery = query.value;
            if (searchTimeout) clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                loadOptions();
            }, 250);
        }

        function loadOptions() {
            axios.get(endpoint, { params: { query: query.value, identifiers: identifiers.value }}).then((response) => {
                callback({ results: response.data });
            }).catch((error) => {
                callback({ error: error });
            })
        }

        watch(() => identifiers, (_, oldValue) => {
            if (oldValue === undefined) {
                loadOptions();
            }
        }, {
            immediate: true
        });

        watch(() => endpoint, () => {
            loadOptions();
        });

        watch(query, () => {
            search();
        });
    }
}